<template>
    <div class="brand-home">
        <bookNav :showSearch="true" searchStyle="brand"
            @bkSearchShow="bkSearchShow" @bkSearchHide="bkSearchHide"
        ></bookNav>
        <div :class="bkSearchTabShow ? 'brand-fb cur' : 'brand-fb'">
            <div class="left-info">
                <div class="m-info">
                    <img v-if="brandDetailList.image" :src="'https://dhc.library.sh.cn/bkimg/pp/'+brandDetailList.image" alt="">
                    <div class="txt">
                        <h4>{{brandDetailList.name}}</h4>
                        <div class="des">
                            {{brandDetailList.description}}
                        </div>
                    </div>
                </div>
                <div class="descriptions">
                    <div class="d-l">
                        <div class="ds" v-if="brandDetailList.creator">
                            <span>品牌创始人</span>
                            <span>{{brandDetailList.creator}}</span>
                        </div>
                        <div class="ds" v-if="brandDetailList.created">
                            <span>品牌创建时间</span>
                            <span>{{brandDetailList.created+'年'}}</span>
                        </div>
                        <div class="ds" v-if="brandDetailList.place && brandDetailList.place.chsPlc">
                            <span>品牌创建地点</span>
                            <span>{{brandDetailList.place.chsPlc}}</span>
                        </div>
                        <div class="ds" v-if="brandDetailList.bmname">
                            <span>品牌别名</span>
                            <span>{{brandDetailList.bmname.label}}</span>
                        </div>
                        <div class="ds" v-if="brandDetailList.organization && brandDetailList.organization.chsName">
                            <span>品牌所属公司</span>
                            <span>{{brandDetailList.organization.chsName['@value']}}</span>
                        </div>
                        <div class="ds" v-if="brandDetailList.organization && brandDetailList.organization.event">
                            <span>所属公司名变迁</span>
                            <span v-html="brandDetailList.organization.event.split('；').join('<br/>')">
                            <!-- 1931年富贝康化妆品无限公司<br/> -->
                            </span>
                        </div>
                    </div>
                    <div class="d-l">
                        <div class="ds" v-if="brandDetailList.subBrand">
                            <span>同公司品牌</span>
                            <span v-if="brandDetailList.subBrand.length > 0">
                                {{arrayToString(brandDetailList.subBrand, 'name', '、')}}
                            </span>
                            <span v-else>{{brandDetailList.subBrand.name}}</span>
                        </div>
                        <div class="ds" v-if="brandDetailList.ryname && brandDetailList.ryname.label">
                            <span>品牌荣誉</span>
                            <span v-html="brandDetailList.ryname.label.replace(' ', '').split('；').join('<br/>')"> </span>
                        </div>
                        <div class="ds" v-if="brandDetailList.slogan">
                            <span>品牌宣传语</span>
                            
                            <span v-if="brandDetailList.slogan.indexOf('；') != -1" 
                                v-html="brandDetailList.slogan.replace(' ', '').split('；').join('<br/>')"
                            ></span>
                            <span v-else v-html="brandDetailList.slogan.split(' ').join('<br/>')"></span>
                        </div>
                        <div class="ds" v-if="brandDetailList.product && arrayToString(brandDetailList.product, 'name', '、')">
                            <span>主要产品</span>
                            <span>{{arrayToString(brandDetailList.product, 'name', '、')}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-content" v-if="brandDetailList.person || resultList.length > 0">
                <div class="side-about" v-if="brandDetailList && brandDetailList.person">
                    <!--  <a-icon type="down" /> -->
                    <div class="tit">相关名人<span @click="personMore">查看更多<a-icon type="right" /></span></div>
                    <div class="fms-list" v-if="brandDetailList.person && brandDetailList.person.length > 0">
                        <a href="javascript:;" class="fms" @click="personSkip(person)"
                            v-for="(person, pn) in brandDetailList.person" :key="'person'+pn"
                        >
                            <img :src="'//img.library.sh.cn/person/'+person['@id'].slice(-16)+'.jpg!300X300'" 
                                onerror="onerror=null;src='/user3.png';console.clear()" alt=""
                            >
                            <div class="name">{{person.chsName['@value']}}</div>
                        </a>
                    </div>
                    <div class="fms-list" v-else-if="brandDetailList.person && brandDetailList.person.chsName">
                        <a href="javascript:;" class="fms" @click="personSkip(brandDetailList.person)">
                            <img :src="'//img.library.sh.cn/person/'+brandDetailList.person['@id'].slice(-16)+'.jpg'" 
                                onerror="onerror=null;src='/user3.png';console.clear()" alt=""
                            >
                            <div class="name">{{brandDetailList.person.chsName['@value']}}</div>
                        </a>
                    </div>
                </div>
                <div class="side-about" v-if="resultList && resultList.length>0">
                     <!-- <a-icon type="down" /> -->
                    <div class="tit">相关广告<span @click="more">查看更多<a-icon type="right" /></span></div>
                    <!-- <div class="brand-list">
                        <router-link to="/bk/brandDetail/1">花月</router-link>
                        <router-link to="/bk/brandDetail/1">其他品牌</router-link>
                        <router-link to="/bk/brandDetail/1">其他品牌</router-link>
                        <router-link to="/bk/brandDetail/1">其他品牌</router-link>
                        <router-link to="/bk/brandDetail/1">其他品牌</router-link>
                        <router-link to="/bk/brandDetail/1">其他品牌</router-link>
                    </div> -->
                    <div class="fms-list">
                        <a href="javascript:;" class="fms" 
                            v-for="(item, index) in resultList" :key="'ad'+index"
                            @click="advertisementimg(item, index)"
                        >
                            <img :src="item.imgUrl" alt="">
                            <div class="name" :title="item.title">{{item.title.slice(0,10)+'...'}}</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bookNav from './../nav2'
    export default {
        components:{
            bookNav
        },
        computed:{
            dateCount(){
                if(this.choseYear===''||this.choseMonth===''){
                    return 30
                }else{
                    return new Date(this.choseYear,this.choseMonth,0).getDate()
                }
            },
            params(){
                return {
                    uri: this.brandDetailUri,
                }
            },
            adSearchParams(){ // 广告查询参数
                return {
                    "searchType": this.adSearchType,
                    "expression": " ",
                    "freetext": "",
                    "cdtn": this.adCdtn,
                    "facet": this.adFacet,
                    "secondCdtn": "",
                    "pager": {
                        "pageth": this.adPageth,
                        "pageSize": this.adPageSize
                    },
                    "sorts": {
                        'SJ': "0"
                    },
                    "hasFacet": true
                }
            },
            // activePerson: function(){
            //     if(typeof this.brandDetailList.person == 'string') return this.brandDetailList.person;
            //     return this.brandDetailList.person.filter(function(item) {
            //         return item.chsName['@value']
            //     })
            // },
        },
        data(){
            return{
                bkSearchTabShow:false,
                brandDetailUri: 'http://data.library.sh.cn/bk/resource/brand/xa506qjyn4u1hxuq',
                brandDetailList: [],
                ImageUri: '/user3.png',
                adSearchType: 2,// 检索类型， 1：简单检索，2：高级检索，3：专业检索
                adCdtn: [],     // 广告查询高级检索
                adFacet: {},    // 广告查询分面检索
                adPageth: 1,    // 第几页
                adPageSize: 3,  // 广告检索，每页检索数量
                resultList: [], // 广告列表
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getBrandDetail();
            })
        },
        methods:{
            getBrandDetail(){
                this.params.uri = localStorage.brandDetailUri;
                this.brandDetailAxios(); // 品牌
                this.getAdvertising();   // 品牌广告
            },
            getAdvertising(){
                this.adCdtn = [{
                    "logic": "and",
                    "field": "brandUri",
                    "value": this.params.uri,
                    "type": "1"
                }]
                this.adSearch(); // 广告查询
            },
            brandDetailAxios(){ // 海派品牌详情获取
                this.$axios.get(this.bkCommon.brandDetailUrl, {params: this.params})
                .then((res) => {
                    let resultData = res.data;
                    this.brandDetailList = resultData.data;
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            adSearch(){ // 品牌广告
                this.$axios.post( this.bkCommon.adSearchUrl, this.adSearchParams)
                .then((res) => {
                    let resultData = res.data;
                    this.resultList = resultData.datas;
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            personSkip(person){ // 相关名人点击
                let personUri = person['@id'];
                if(personUri.indexOf('/bk/') == -1){
                    window.open(personUri)
                }
            },
            personMore(){ // 相关名人，查看更多
                window.open("//names.library.sh.cn/")
            },
            more(){ // 查看更多
                this.$router.push('/bk/brandResult');
            },
            advertisementimg(data, index){ // 跳转全文
                localStorage.advertisementData = this.$qs.stringify(data);
                this.$router.push('/bk/advertisementimg');
            },
            bkSearchShow(visible){
                this.bkSearchTabShow = visible;
                this.unScroll(); // 禁止滚动条滚动
            },
            bkSearchHide(visible){
                this.bkSearchTabShow = visible;
                this.removeUnScroll(); // 移除禁止滚动条滚动
            }
        }
    }
</script>

<style lang="less" scoped>
    .brand-home{
        background: #e3e3e3;
        .brand-fb{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 0 2%;
            &.cur{
                opacity: 0.1;
            }
        }
        .left-info{
            flex-grow: 1;
            margin-right: 20px;
            border-radius: 10px;
            padding: 30px;
            background: #f7f7f7;
            .descriptions{
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                margin-top: 20px;
                padding: 0 20px;
                .d-l{
                    background: url("./desbg.png") repeat;
                    width: 50%;
                    height: auto;
                    box-sizing: border-box;
                    border-bottom: 1px solid #ddd;
                    .ds{
                        display: flex;
                        span{
                            padding-right: 2%;
                            line-height: 34px;
                            display: block;
                            &:first-child{
                                font-weight: bold;
                                color: #666;
                                width: 110px;
                                flex-shrink: 0;
                                height: 34px;
                            }
                            &:nth-child(2){
                                color: #999;
                                flex: 1;
                            }
                        }
                    }
                }
            }
            .m-info{
                display: flex;
                padding: 0 20px;
                img{
                    width: 240px;
                    height: 240px;
                    border-radius: 10px;
                    margin-right: 20px;
                    flex-shrink: 0;
                }
                .txt{
                    flex: 1;
                    h4{
                        font-size: 16px;
                        color: #1473a5;
                        line-height: 1.3;
                        font-weight: bold;
                        margin-bottom: 10px;
                    }
                    .des{
                        color: #666;
                        font-size: 14px;
                        line-height: 1.8;
                    }
                }
            }
        }
        .right-content{
            width: 40%;
            min-width: 300px;
            max-width: 380px;
            flex-shrink: 0;
            .side-about{
                background: #fff;
                border-radius: 10px;
                padding: 20px;
                margin-bottom: 20px;
                .brand-list{
                    display: flex;
                    margin-top: 20px;
                    flex-wrap: wrap;
                    a{
                        width: 33.3%;
                        margin-bottom: 5px;
                        color: #666;
                        text-decoration: underline;
                    }
                }
                .tit{
                    font-size: 16px;
                    color: #1473a5;
                    font-weight: bold;
                    span{
                        float: right;
                        font-size: 14px;
                        color: #1473a5;
                        font-weight: normal;
                        line-height: 20px;
                        cursor: pointer;
                    }
                }
                .fms-list{
                    // display: flex;
                    // flex-wrap: wrap;
                    // justify-content: space-between;
                    grid-template-columns: repeat(3,1fr);
                    display: grid;
                    grid-gap: 0 35px;
                    place-items: center;
                    margin-top: 25px;
                    .fms{
                        width: 90px;
                        height: auto;
                        flex-shrink: 0;
                        text-align: center;
                        margin-bottom: 5px;
                        img{
                            width: 90px;
                            height: 90px;
                            border-radius: 50%;
                            display: block;
                            margin-bottom: 10px;
                        }
                        .name{
                            line-height: 19px;
                            margin-bottom: 5px;
                            color: #666;
                            text-decoration: underline;
                            max-height: 38px;
                            overflow: hidden;
                        }
                        .tag{
                            line-height: 1.3;
                            color: #888;
                        }
                    }
                }
            }
        }
    }
</style>
